module.exports = __webpack_public_path__ + "static/media/broccoli.a23a5353.jpg";